module.exports = __webpack_public_path__ + "img/jd.9f391c61.jpg";